export default __webpack_public_path__ + "static/media/es.dc5cff31.png";